import React, { useState } from "react";

/**
 * Dashboard tabs component.
 *
 * Renders the top-level tabs shown on the dashboard:
 *   - bt360 Wealth
 *   - bt360 Tax        (contains its own nested tabs: Tax Harvesting / Transaction Report)
 *   - Estate Mapping
 *
 * The visual style follows the tab system already used across the app
 * (see assets/scss/components/_components.tabs.scss), adapted to the
 * dashboard design with the orange underline on the active tab.
 *
 * State is managed as "steps" so each tab shows one thing or another.
 */
const DashboardTabs = (props) => {
  const {
    tab = "wealth",
    onTabChange,
    renderTabContent,
  } = props;

  const tabs = [
    { key: "wealth", label: "bt360 Wealth" },
    { key: "tax", label: "bt360 Tax" },
    { key: "estate", label: "Estate Mapping" },
  ];

  // Nested tabs only relevant when the parent "tax" tab is active.
  const taxTabs = [
    { key: "harvesting", label: "Tax Harvesting" },
    { key: "transaction", label: "Transaction Report" },
  ];

  const [taxSubTab, setTaxSubTab] = useState("harvesting");

  const handleParentTab = (key) => {
    onTabChange && onTabChange(key);
  };

  const handleTaxSubTab = (key) => {
    setTaxSubTab(key);
  };

  return (
    <div className="c-dashboard-tabs">
      {/* Primary tabs */}
      <div className="c-tabs__wrapper">
        <div className="c-tabs__container">
          {tabs.map((t) => (
            <div
              key={t.key}
              className={`c-tabs ${tab === t.key ? "is-active" : ""}`}
              onClick={() => handleParentTab(t.key)}
            >
              <span className="c-tabs__text">{t.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="c-dashboard-tabs__content">
        {tab === "wealth" && (
          <div className="c-dashboard-tabs__panel">
            {renderTabContent && renderTabContent("wealth")}
          </div>
        )}

        {tab === "tax" && (
          <div className="c-dashboard-tabs__panel">
            <div className="c-tabs__wrapper">
              <div className="c-tabs__container">
                {taxTabs.map((t) => (
                  <div
                    key={t.key}
                    className={`c-tabs ${taxSubTab === t.key ? "is-active" : ""}`}
                    onClick={() => handleTaxSubTab(t.key)}
                  >
                    <span className="c-tabs__text">{t.label}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="c-dashboard-tabs__sub-content">
              {taxSubTab === "harvesting" && (
                <>{renderTabContent && renderTabContent("tax-harvesting")}</>
              )}
              {taxSubTab === "transaction" && (
                <>{renderTabContent && renderTabContent("tax-transaction")}</>
              )}
            </div>
          </div>
        )}

        {tab === "estate" && (
          <div className="c-dashboard-tabs__panel">
            {renderTabContent && renderTabContent("estate")}
          </div>
        )}
      </div>
    </div>
  );
};

export default DashboardTabs;
